/* eslint-disable */
import { Dialog, Toast } from 'vant';
import { MessageBox, Message } from "element-ui";
import { api, merchantapi } from "./env";
import wx from "@/assets/js/jweixin-1.6.0";
import '@/assets/css/loginPop.css'
import Vue from 'vue'
import Verify from "../components/verifition/Verify.vue";
// import '@/assets/js/captcha/crypto-js.js'
// import '@/assets/js/captcha/ase.js'
// import '@/assets/js/captcha/verify.js'
// import '@/assets/js/captcha/verify.css'
import { get, post } from "./request";
import NativeShare from "@/assets/js/NativeShare";
import Geolocation from "tencent-geolocation-vue"
//是否是在微信环境
const isWeixin = () => {
    return navigator.userAgent.toLowerCase().match(/micromessenger/i) && navigator.userAgent.toLowerCase().match(/MicroMessenger/i)[0] === "micromessenger"
}
//是否是在支付宝环境
const isAlipay = () => {
    return navigator.userAgent.toLowerCase().match(/AlipayClient/i) && navigator.userAgent.toLowerCase().match(/AlipayClient/i)[0] === "alipayclient"
}
//是否是android手机
const isAndroid = () => {
    const u = navigator.userAgent
    return u.indexOf('Android') > -1 || u.indexOf('Linux') > -1;
}
//是否是ios手机
const isIOS = () => {
    const u = navigator.userAgent
    return !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
}
//是否是鸿蒙手机
const isHarmonyOS = () => {
    const u = navigator.userAgent.toLowerCase()
    console.log(u)
    return u.indexOf('harmonyos') > -1 || u.indexOf('huawei') > -1;
}


const isPhone = () => {
    console.log(1111)
    return /phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone/i.test(navigator.userAgent)
}
//判断微信环境小程序或公众号
const getWXEvn = config => {
    wx.miniProgram.getEnv(function (res) {
        if (res.miniprogram) {
            if (config.isMiniApp) {
                config.isMiniApp()
            }
        } else {
            if (config.isWeixinNotMiniApp) {
                config.isWeixinNotMiniApp()
            }
        }
    })
}
const isBangBangApp = () => {
    return navigator.userAgent.toLowerCase().match(/BangbangApp/i) && navigator.userAgent.toLowerCase().match(/BangbangApp/i)[0] === "bangbangapp"
}
const getLocalStorage = (...args) => {
    const storage = {};
    args.forEach(arg => {
        storage[arg] = window.localStorage.getItem(arg) || null;
    });
    return storage;
};

const setLocalStorage = data => {
    Object.keys(data).forEach(prop => {
        const el = data[prop];
        window.localStorage.setItem(prop, el);
    });
};

const removeLocalStorage = (...args) => {
    args.forEach(arg => {
        window.localStorage.removeItem(arg);
    });
};
//获取cookie
const getCookie = (c_name) => {
    var arr, reg = new RegExp("(^| )" + c_name + "=([^;]*)(;|$)");
    if (arr = document.cookie.match(reg))
        return unescape(arr[2]);
    else
        return null;
}
//设置cookie
const setCookie = (c_name, value, expire) => {
    var date = new Date()
    date.setSeconds(date.getSeconds() + expire)
    document.cookie = c_name + "=" + escape(value) + "; expires=" + date.toGMTString() + "; path=/"
}
//清除cookie
const clearCookie = (c_name) => {
    setCookie(c_name, '', 365 * 24 * 60 * 60)
}
//获取url参数
const getQueryString = (name) => {
    var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
    console.log(window.location.search)
    var r = window.location.search.substr(1).match(reg);
    console.log(r)
    if (r !== null) return unescape(r[2]); return null;
}
//校验手机号
const checkPhoneNo = phoneNo => {
    return /^1\d{10}$/gi.test(phoneNo);
}
//清空表单
const clearForm = (fromClass) => {
    $(':input', '.' + fromClass)
        .not(':button,:submit,:reset,:hidden')
        .val('')
        .removeAttr('checked')
        .removeAttr('checked')
}
/**
 * 初始化登录
 * @param {snsapi_base:静默授权，snsapi_userinfo:强制授权，snsapi_subscribe:订阅关注} cfg.scope
 * @param {是否需要登陆弹窗} cfg.needLoginModal
 * @param {是否强制登录} cfg.isForce
 * @param {微信授权重定向地址} cfg.callBackUrl
 * @param {登陆成功回调} cfg.success
 * @param {是否只在公众号环境} cfg.onlyWX
 * @param {登陆失败回调} cfg.fail
 */
const initLogin = (cfg) => {
    const scope = cfg.scope || 'snsapi_userinfo'
    let callBackUrl = cfg.callBackUrl || location.href
    const needLoginModal = cfg.hasOwnProperty('needLoginModal') ? cfg.needLoginModal : true
    const isForce = cfg.hasOwnProperty('isForce') ? cfg.isForce : true
    const onlyWX = cfg.hasOwnProperty('onlyWX') ? cfg.onlyWX : false
    //如果未登录
    if (!getCookie("token")) {
        //如果是微信环境
        if (onlyWX || isWeixin()) {
            if (onlyWX) {
                const sessionKey = getQueryString("sessionKey");
                const isBind = getQueryString("isBind");
                const token = getQueryString("access_token");
                const userId = getQueryString("userId");
                if (scope === "snsapi_subscribe") {
                    if (callBackUrl.indexOf("?") >= 0) {
                        callBackUrl = callBackUrl + "&isFollow=1";
                    } else {
                        callBackUrl = callBackUrl + "?isFollow=1";
                    }
                }
                if (!sessionKey) {
                    location.href =
                        api +
                        "api/wechatAccount/weChatCallBack?scope=" +
                        scope +
                        "&callBackUrl=" +
                        encodeURIComponent(callBackUrl);
                    return;
                }
                if (isBind === "1") {
                    //如果微信已绑定自动登录成功
                    loginSuccess({
                        token,
                        userId
                    });
                } else {
                    //unionId未注册未绑定，弹窗登录
                    loginFail({
                        sessionKey
                    })
                    if (needLoginModal) {
                        openLoginPop({
                            sessionKey,
                            isForce
                        })
                    }
                }
            } else {
                getWXEvn({
                    //如果是小程序
                    isMiniApp: () => {
                        if (getQueryString("access_token")) {
                            loginSuccess({
                                token: getQueryString("access_token"),
                                userId: getQueryString("userId")
                            });
                        } else {
                            const str = location.href; //取得整个地址栏
                            const strList = str.split("?");
                            const arr = strList[1] ? strList[1].split("&").filter(item => {
                                return !(item.includes('access_token') || item.includes('userId'))
                            }) : []
                            wx.miniProgram.navigateTo({
                                url: `/pages/authorize/authorize?from=commonh5&redirectUrl=${strList[0]}?${arr.join('&')}`,
                            });
                        }
                    },
                    //如果是公众号网页
                    isWeixinNotMiniApp: () => {
                        const sessionKey = getQueryString("sessionKey");
                        const isBind = getQueryString("isBind");
                        const token = getQueryString("access_token");
                        const userId = getQueryString("userId");
                        if (scope === "snsapi_subscribe") {
                            if (callBackUrl.indexOf("?") >= 0) {
                                callBackUrl = callBackUrl + "&isFollow=1";
                            } else {
                                callBackUrl = callBackUrl + "?isFollow=1";
                            }
                        }
                        if (!sessionKey) {
                            location.href =
                                api +
                                "api/wechatAccount/weChatCallBack?scope=" +
                                scope +
                                "&callBackUrl=" +
                                encodeURIComponent(callBackUrl);
                            return;
                        }
                        if (isBind === "1") {
                            //如果微信已绑定自动登录成功
                            loginSuccess({
                                token,
                                userId
                            });
                        } else {
                            //unionId未注册未绑定，弹窗登录
                            loginFail({
                                sessionKey
                            })
                            if (needLoginModal) {
                                openLoginPop({
                                    sessionKey,
                                    isForce
                                })
                            }
                        }
                    }
                });
            }

        } else if (isBangBangApp()) {
            //在app中
            const timer = setInterval(function () {
                if (isAndroid()) {
                    if (window.synopsis.getUserInfo) {
                        clearInterval(timer);
                        window.synopsis.getUserInfo();
                    }
                } else if (isIOS()) {
                    if (window.webkit.messageHandlers.getUserInfo) {
                        clearInterval(timer);
                        window.webkit.messageHandlers.getUserInfo.postMessage("");
                    }
                }
            }, 1000 / 60);
            window.sendUserInfo = (token, userId, userRole) => {
                if (token === 'null') {
                    navigateToApp('szbb://weex/login.js?swipeBack=false')
                    return
                }
                loginSuccess({
                    token: token,
                    userId: userId
                });
            };
        } else {
            loginFail()
            if (needLoginModal) {
                openLoginPop({
                    isForce
                })
            }
        }
    } else {
        if (isWeixin()) {
            getWXEvn({
                isMiniApp: () => {
                    if (getQueryString("access_token")) {
                        //如果在小程序中
                        loginSuccess({
                            token: getQueryString("access_token"),
                            userId: getQueryString("userId")
                        });

                    } else {
                        loginSuccess({
                            token: getCookie("token"),
                            userId: getCookie("userId")
                        });
                    }
                },
                isWeixinNotMiniApp: () => {
                    loginSuccess({
                        token: getCookie("token"),
                        userId: getCookie("userId")
                    });
                }
            });
        } else if (isBangBangApp()) {
            //在app中
            const timer = setInterval(function () {
                if (isAndroid()) {
                    if (window.synopsis.getUserInfo) {
                        clearInterval(timer);
                        window.synopsis.getUserInfo();
                    }
                } else if (isIOS()) {
                    if (window.webkit.messageHandlers.getUserInfo) {
                        clearInterval(timer);
                        window.webkit.messageHandlers.getUserInfo.postMessage("");
                    }
                }
            }, 1000 / 60);
            window.sendUserInfo = (token, userId, userRole) => {
                loginSuccess({
                    token: token,
                    userId: userId
                });
            };
        } else {
            loginSuccess({
                token: getCookie("token"),
                userId: getCookie("userId")
            });
        }
    }

    function loginSuccess(config) {
        setCookie("token", config.token, 365 * 24 * 60 * 60);
        setCookie("userId", config.userId, 365 * 24 * 60 * 60);
        console.log(cfg)
        if (cfg.success) {
            cfg.success({
                token: config.token,
                userId: config.userId
            })
        }
    }
    function loginFail(config) {
        cfg.fail && cfg.fail({
            sessionKey: config && config.sessionKey ? config.sessionKey : ''
        })
    }
    function openLoginPop(config) {
        if (isPhone()) {
            Dialog.confirm({
                message:
                    '<form class="register_form" action="">' +
                    '<div class="input_control">' +
                    '<input type="number" placeholder="手机号" name="phoneNum" />' +
                    "</div>" +
                    '<div class="input_control">' +
                    '<input type="number" placeholder="手机验证码" name="code" />' +
                    '<span class="sendCode">获取验证码</span>' +
                    "</div>" +
                    "</form>",
                confirmButtonText: "登录/注册",
                confirmButtonColor: "#fb3e47",
                showCancelButton: !config.isForce,
                beforeClose(action, done) {
                    var $register_form = $('.register_form')
                    var phoneNo = $register_form.serializeArray()[0].value
                    var code = $register_form.serializeArray()[1].value
                    done(false)
                    if (action === 'confirm') {
                        if (!checkPhoneNo(phoneNo)) {
                            Toast('手机号码错误')
                            return
                        }
                        if (code === "") {
                            Toast("请输入验证码");
                            return;
                        }
                        get({
                            url: api + 'api/v2/engineer/register.json',
                            data: {
                                phonenumber: phoneNo,
                                code: code,
                                version: '3.0.20',
                                sessionKey: config.sessionKey,
                                reg_source: getQueryString('utm_source') || 'webH5'
                            },
                            requestType: 3
                        }).then(data => {
                            if (data.result === "success") {
                                loginSuccess({
                                    token: data.body.access_token,
                                    userId: data.body.userId,
                                })
                                if (cfg.success) {
                                    Dialog.close()
                                    return
                                }
                                location.reload()
                            } else {
                                Toast(data.message)
                            }
                        })
                    } else {
                        Dialog.close()
                    }
                }
            })

        } else {
            MessageBox({
                title: '消息',
                message: '<form class="register_form register_form--pc" action="">' +
                    '<div class="input_control">' +
                    '<input placeholder="手机号" name="phoneNum" />' +
                    "</div>" +
                    '<div class="input_control">' +
                    '<input placeholder="手机验证码" name="code" />' +
                    '<span class="sendCode">获取验证码</span>' +
                    "</div>" +
                    "</form>",
                showCancelButton: true,
                dangerouslyUseHTMLString: true,
                confirmButtonText: '登录/注册',
                cancelButtonText: '取消',
                beforeClose: (action, instance, done) => {
                    if (action === 'confirm') {
                        var $register_form = $('.register_form')
                        var phoneNo = $register_form.serializeArray()[0].value
                        var code = $register_form.serializeArray()[1].value
                        if (!checkPhoneNo(phoneNo)) {
                            Message.error('手机号码错误')
                            return
                        }
                        if (code === "") {
                            Message.error("请输入验证码");
                            return;
                        }
                        instance.confirmButtonLoading = true;
                        instance.confirmButtonText = '登录中...';
                        get({
                            url: api + 'api/v2/engineer/register.json',
                            data: {
                                phonenumber: phoneNo,
                                code: code,
                                version: '3.0.20',
                                sessionKey: config.sessionKey,
                                reg_source: getQueryString('utm_source') || 'webH5'
                            },
                            requestType: 3
                        }).then(data => {
                            if (data.result === "success") {
                                loginSuccess({
                                    token: data.body.access_token,
                                    userId: data.body.userId,
                                })
                                if (cfg.success) {
                                    instance.confirmButtonLoading = false;
                                    done();
                                    return
                                }
                                location.reload()
                            } else {
                                instance.confirmButtonLoading = false;
                                Message.error(data.message)
                            }
                        })
                    } else {
                        instance.confirmButtonLoading = false;
                        done();
                    }
                }
            })
        }
        setTimeout(() => {
            $('input').off('blur')
            $('.sendCode').off('click')
            $('input').on('blur', function () {
                var scrollHeight = document.documentElement.scrollTop || document.body.scrollTop || 0;
                window.scrollTo(0, Math.max(scrollHeight - 1, 0));
                document.activeElement.scrollIntoViewIfNeeded(true);
            })
            const verify = new Vue({
                render: h => {
                    return h(Verify, {
                        ref: 'verify',
                        props: {
                            mode: 'pop',
                            captchaType: 'blockPuzzle',
                            imgSize: { width: '330px', height: '155px' }
                        }
                    })
                },
            }).$mount('#verify_w')
            //发送验证码
            var $sendCode = $('.sendCode');
            var $register_form = $('.register_form')
            var isSend = false;
            var count = 60;
            function jishi() {
                isSend = true;
                if (count === 0) {
                    $sendCode.text('重新发送验证码');
                    isSend = false;
                    count = 60;
                    return;
                }
                count--;
                $sendCode.text('剩余' + count + 's')
                setTimeout(function () {
                    jishi();
                }, 1000)
            }
            $sendCode.on('click', function () {
                if (!isSend) {
                    var phoneNo = $register_form.serializeArray()[0].value
                    if (!checkPhoneNo(phoneNo)) {
                        Toast('手机号码错误')
                        return
                    }
                    verify.$refs.verify.show().then(res => {
                        post({
                            url: api + 'api/SMSVerification/sendSMS',
                            data: {
                                accessPhonenumber: phoneNo,
                                captchaVerification: res.captchaVerification,
                                useInterface: '/api/v2/engineer/register.json'
                            },
                            requestType: 3
                        }).then(data => {
                            if (data.result === "success") {
                                Toast('验证码已发送，请注意查收')
                                jishi();
                            } else {
                                Toast(data.message)
                            }
                        })

                    })
                }
            })
        }, 200);
    }
}
const initLogin2 = (cfg) => {
    const scope = cfg.scope || 'snsapi_userinfo'
    let callBackUrl = cfg.callBackUrl || location.href
    const onlyWX = cfg.hasOwnProperty('onlyWX') ? cfg.onlyWX : false
    const needLoginModal = cfg.hasOwnProperty('needLoginModal') ? cfg.needLoginModal : true
    //如果未登录
    if (!getCookie("bktoken") || getCookie("bktoken") === "") {
        if (onlyWX || isWeixin()) {
            if (onlyWX) {
                const openId = getQueryString("openId");
                const token = getQueryString("access_token");
                if (scope === "snsapi_subscribe") {
                    if (callBackUrl.indexOf("?") >= 0) {
                        callBackUrl = callBackUrl + "&isFollow=1";
                    } else {
                        callBackUrl = callBackUrl + "?isFollow=1";
                    }
                }
                if ((!openId || openId === '') && (!token || token === '')) {
                    location.href =
                        merchantapi +
                        "wechat/weChatCallBack?scope=" +
                        scope +
                        "&callBackUrl=" +
                        encodeURIComponent(callBackUrl);
                    return;
                }
                if (token && token !== '') {
                    //如果微信已绑定自动登录成功
                    loginSuccess({
                        token
                    });
                } else {
                    //unionId未注册未绑定，弹窗登录
                    loginFail({
                        openId
                    })
                    if (needLoginModal) {
                        openLoginPop({
                            openId
                        })
                    }
                }
            } else {
                getWXEvn({
                    //如果是小程序
                    isMiniApp: () => {
                        if (getQueryString("access_token")) {
                            loginSuccess({
                                token: getQueryString("access_token")
                            });
                        } else {
                            const str = location.href; //取得整个地址栏
                            const strList = str.split("?");
                            const arr = strList[1] ? strList[1].split("&").filter(item => {
                                return !(item.includes('access_token') || item.includes('userId'))
                            }) : []
                            wx.miniProgram.navigateTo({
                                url: `/pages/authorize/authorize?from=commonh5&redirectUrl=${strList[0]}?${arr.join('&')}`,
                            });
                        }
                    },
                    //如果是公众号网页
                    isWeixinNotMiniApp: () => {
                        const openId = getQueryString("openId");
                        const token = getQueryString("access_token");
                        if (scope === "snsapi_subscribe") {
                            if (callBackUrl.indexOf("?") >= 0) {
                                callBackUrl = callBackUrl + "&isFollow=1";
                            } else {
                                callBackUrl = callBackUrl + "?isFollow=1";
                            }
                        }
                        if ((!openId || openId === '') && (!token || token === '')) {
                            location.href =
                                merchantapi +
                                "wechat/weChatCallBack?scope=" +
                                scope +
                                "&callBackUrl=" +
                                encodeURIComponent(callBackUrl);
                            return;
                        }
                        if (token && token !== '') {
                            //如果微信已绑定自动登录成功
                            loginSuccess({
                                token
                            });
                        } else {
                            //unionId未注册未绑定，弹窗登录
                            loginFail({
                                openId
                            })
                            if (needLoginModal) {
                                openLoginPop({
                                    openId
                                })
                            }
                        }
                    }
                });
            }
        }
    } else {
        if (isWeixin()) {
            getWXEvn({
                isMiniApp: () => {
                    //如果在小程序中
                    loginSuccess({
                        token: getQueryString("access_token")
                    });
                },
                isWeixinNotMiniApp: () => {
                    loginSuccess({
                        token: getCookie("token")
                    });
                }
            });
        } else {
            loginSuccess({
                token: getCookie("token")
            });
        }
    }
    function loginSuccess(config) {
        setCookie("bktoken", config.token, 365 * 24 * 60 * 60);
        cfg.success && cfg.success({
            token: config.token
        })
    }
    function loginFail(config) {
        cfg.fail && cfg.fail({
            openId: config && config.openId ? config.openId : ''
        })
    }
    function openLoginPop(config) {
        Dialog.confirm({
            message:
                '<form class="register_form" action="">' +
                '<div class="input_control">' +
                '<input type="number" placeholder="手机号" name="phoneNum" />' +
                "</div>" +
                '<div class="input_control">' +
                '<input type="number" placeholder="手机验证码" name="code" />' +
                '<span class="sendCode">获取验证码</span>' +
                "</div>" +
                "</form>",
            confirmButtonText: "登录/注册",
            confirmButtonColor: "#fb3e47",
            showCancelButton: !config.isForce,
            beforeClose(action, done) {
                var $register_form = $('.register_form')
                var phoneNo = $register_form.serializeArray()[0].value
                var code = $register_form.serializeArray()[1].value
                done(false)
                if (action === 'confirm') {
                    if (!checkPhoneNo(phoneNo)) {
                        Toast('手机号码错误')
                        return
                    }
                    if (code === "") {
                        Toast("请输入验证码");
                        return;
                    }
                    get({
                        url: api + 'api/v2/engineer/register.json',
                        data: {
                            phonenumber: phoneNo,
                            code: code,
                            version: '3.0.20',
                            openId: config.openId,
                            reg_source: getQueryString('utm_source') || 'webH5'
                        },
                        requestType: 3
                    }).then(data => {
                        if (data.result === "success") {
                            loginSuccess({
                                token: data.body.access_token,
                                userId: data.body.userId,
                            })
                            location.reload()
                        } else {
                            Toast(data.message)
                        }
                    })
                } else {
                    Dialog.close()
                }
            }
        })
        setTimeout(() => {
            $('input').on('blur', function () {
                var scrollHeight = document.documentElement.scrollTop || document.body.scrollTop || 0;
                window.scrollTo(0, Math.max(scrollHeight - 1, 0));
                document.activeElement.scrollIntoViewIfNeeded(true);
            })
            const verify = new Vue({
                render: h => {
                    return h(Verify, {
                        ref: 'verify',
                        props: {
                            mode: 'pop',
                            captchaType: 'blockPuzzle',
                            imgSize: { width: '330px', height: '155px' }
                        }
                    })
                },
            }).$mount('#verify_w')
            //发送验证码
            var $sendCode = $('.sendCode');
            var $register_form = $('.register_form')
            var isSend = false;
            var count = 60;
            function jishi() {
                isSend = true;
                if (count === 0) {
                    $sendCode.text('重新发送验证码');
                    isSend = false;
                    count = 60;
                    return;
                }
                count--;
                $sendCode.text('剩余' + count + 's')
                setTimeout(function () {
                    jishi();
                }, 1000)
            }
            $sendCode.on('click', function () {
                if (!isSend) {
                    var phoneNo = $register_form.serializeArray()[0].value
                    if (!checkPhoneNo(phoneNo)) {
                        Toast('手机号码错误')
                        return
                    }
                    verify.$refs.verify.show().then(res => {
                        post({
                            url: api + 'api/SMSVerification/sendSMS',
                            data: {
                                accessPhonenumber: phoneNo,
                                captchaVerification: res.captchaVerification,
                                useInterface: '/api/v2/engineer/register.json'
                            },
                            requestType: 3
                        }).then(data => {
                            if (data.result === "success") {
                                Toast('验证码已发送，请注意查收')
                                jishi();
                            } else {
                                Toast(data.message)
                            }
                        })

                    })
                }
            })
        }, 200);
    }
}
const openLoginPop = (cfg) => {
    Dialog.confirm({
        title: cfg.title || '',
        message:
            '<form class="register_form" action="">' +
            '<div class="input_control">' +
            '<input type="number" placeholder="手机号" name="phoneNum" />' +
            "</div>" +
            '<div class="input_control">' +
            '<input type="number" placeholder="手机验证码" name="code" />' +
            '<span class="sendCode">获取验证码</span>' +
            "</div>" +
            '<div class="login_agree">' +
            '<label for="isAgreee" style="margin-right:.2rem">' +
            '<input id="isAgreee" type="checkbox" name="isAgreee"/>' +
            '<div class="show-box"></div>' +
            '</label>' +
            '<span>我已阅读并同意</span>' +
            '<span class="link link1">《用户协议》</span>' +
            '<span class="link link2">《隐私政策》</span>' +
            "</div>" +
            "</form>",
        confirmButtonText: "登录/注册",
        confirmButtonColor: "#fb3e47",
        beforeClose(action, done) {
            var $register_form = $('.register_form')
            var phoneNo = $register_form.serializeArray()[0].value
            var code = $register_form.serializeArray()[1].value
            done(false)
            if (action === 'confirm') {
                if (!checkPhoneNo(phoneNo)) {
                    Toast('手机号码错误')
                    return
                }
                if (code === "") {
                    Toast("请输入验证码");
                    return;
                }
                if (!$register_form.serializeArray()[2]) {
                    Toast("请阅读并同意《用户协议》与《隐私政策》");
                    return
                }
                get({
                    url: api + 'api/v2/engineer/register.json',
                    data: {
                        phonenumber: phoneNo,
                        code: code,
                        version: '3.0.20',
                        reg_source: cfg.reg_source
                    },
                    requestType: 3
                }).then(data => {
                    if (data.result === "success") {
                        setCookie("token", data.body.access_token, 365 * 24 * 60 * 60);
                        setCookie("userId", data.body.userId, 365 * 24 * 60 * 60);
                        cfg.loginSuccess &&
                            cfg.loginSuccess({
                                token: data.body.access_token,
                                userId: data.body.userId,
                            })
                        Dialog.close()
                        if (cfg.cantReload) {
                            return
                        }
                        location.reload()
                    } else {
                        Toast(data.message)
                    }
                })
            } else {
                Dialog.close()
            }
        }
    })
    setTimeout(() => {
        $('input').off('blur')
        $('.link1').off('click')
        $('.link2').off('click')
        $('.sendCode').off('click')
        $('input').on('blur', function () {
            var scrollHeight = document.documentElement.scrollTop || document.body.scrollTop || 0;
            window.scrollTo(0, Math.max(scrollHeight - 1, 0));
            document.activeElement.scrollIntoViewIfNeeded(true);
        })
        $('.link1').on('click', () => {
            location.href = `${h5}app/register/register_e.html`
        })
        $('.link2').on('click', () => {
            location.href = `https://c.shenzhoubb.com/article/1575881359388`
        })
        const verify = new Vue({
            render: h => {
                return h(Verify, {
                    ref: 'verify',
                    props: {
                        mode: 'pop',
                        captchaType: 'blockPuzzle',
                        imgSize: { width: '330px', height: '155px' }
                    }
                })
            },
        }).$mount('#verify_w')
        //发送验证码
        var $sendCode = $('.sendCode');
        var $register_form = $('.register_form')
        var isSend = false;
        var count = 60;
        function jishi() {
            isSend = true;
            if (count === 0) {
                $sendCode.text('重新发送验证码');
                isSend = false;
                count = 60;
                return;
            }
            count--;
            $sendCode.text('剩余' + count + 's')
            setTimeout(function () {
                jishi();
            }, 1000)
        }
        $sendCode.on('click', function () {
            if (!isSend) {
                var phoneNo = $register_form.serializeArray()[0].value
                if (!checkPhoneNo(phoneNo)) {
                    Toast('手机号码错误')
                    return
                }
                verify.$refs.verify.show().then(res => {
                    post({
                        url: api + 'api/SMSVerification/sendSMS',
                        data: {
                            accessPhonenumber: phoneNo,
                            useInterface: '/api/v2/engineer/register.json',
                            captchaVerification: res.captchaVerification,
                        },
                        requestType: 3
                    }).then(data => {
                        if (data.result === "success") {
                            Toast('验证码已发送，请注意查收')
                            jishi();
                        } else {
                            Toast(data.message)
                        }
                    })
                })
            }
        })
    }, 200);
}
/**
 * 上传压缩图片
 */
const compressImg = (cfg) => {
    let dataURL = cfg.DataURL
    let canvas = document.createElement('canvas') // 创建Canvas对象(画布)
    let context = canvas.getContext('2d')
    let img = new Image()
    img.src = dataURL // 指定图片的DataURL(图片的base64编码数据)
    img.onload = () => {
        let imgW = img.width * 0.5
        let imgH = img.height * 0.5
        canvas.width = imgW
        canvas.height = imgH
        context.drawImage(img, 0, 0, imgW, imgH)
        dataURL = canvas.toDataURL(cfg.fileType, 0.4)
        let bold = dataURLtoBlob(dataURL);
        let file = blobToFile(bold, cfg.fileName);
        cfg.complate(file)
    }
}
const dataURLtoBlob = (dataURL) => {
    let arr = dataURL.split(","),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);
    while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
    }
    let blob = null;
    // 解决低版本浏览器没有new Blob()问题
    try {
        blob = new Blob([u8arr], { type: mime });
    } catch (e) {
        let BlobBuilder = window.BlobBuilder = (
            window.BlobBuilder ||
            window.WebKitBlobBuilder ||
            window.MozBlobBuilder ||
            window.MSBlobBuilder
        );
        if (e.name === "TypeError" && BlobBuilder) {
            let builder = new BlobBuilder();
            builder.append(u8arr);
            blob = builder.getBlob(mime);
        }
    }
    return blob;
}

const blobToFile = (Blob, fileName) => {
    Blob.lastModifiedDate = new Date();
    Blob.name = fileName;
    return Blob;
}

const checkLogin = ({ success, fail, requestType, complate }) => {
    if (getCookie('token')) {
        post({
            url: api + 'api/v2/engineer/tokenLogin',
            data: {
                access_token: getCookie('token'),
                sourceFrom: 'webH5'
            },
            requestType: requestType || 3
        }).then(data => {
            if (data.result === "success") {
                success && success()
            } else {
                fail && fail()
            }
            complate && complate()
        }).catch(() => {
            Toast('请求异常!')
        })
    } else {
        fail && fail()
        complate && complate()
    }
}

/**
 * 初始化分享
 * @param shareBt       分享按钮选择器默认为.share_bt
 * @param shareUrl      要分享的链接
 * @param sharePath     分享出去小程序的跳转路径commonh5
 * @param imgUrl        分享的图片链接
 * @param miniAppImgUrl        小程序分享的图片链接
 * @param title         分享的标题
 * @param desc          分享的描述
 * @param handleClick   如果在非微信环境下点击分享按钮的回调函数
 * @param shareBtCb   点击分享按钮回调
 * @param wxShareType app分享是否分享小程序卡片
 * url后添加&share=1是否显示App端分享按钮
 */
const initShare = function (config) {
    var shareBt = config.shareBt || '.share_bt'
    $(shareBt).off('click')
    if (isWeixin()) {
        getWXEvn({
            isMiniApp() {
                wx.miniProgram.postMessage({
                    data: {
                        shareTitle: config.title,
                        shareImg: config.miniAppImgUrl || '',
                        shareUrl: encodeURIComponent(config.shareUrl),
                        sharePath: config.sharePath
                    }
                });
                $(shareBt).on('click', function () {
                    config.shareBtCb && config.shareBtCb()
                    openShareMask()
                });
            },
            isWeixinNotMiniApp() {
                //初始化分享
                get({
                    url: api + 'server/wechat/getWechatJsapiSign',
                    data: {
                        url: window.location.href
                    },
                    requestType: 3
                }).then(data => {
                    if (data.signature) {
                        wx.config({
                            debug: false, // 开启调试模式,开发时可以开启
                            appId: 'wxa768b40d1481de3d', // 必填，公众号的唯一标识   由接口返回
                            timestamp: data.timestamp, // 必填，生成签名的时间戳 由接口返回
                            nonceStr: data.nonceStr, // 必填，生成签名的随机串 由接口返回
                            signature: data.signature, // 必填，签名 由接口返回
                            jsApiList: ["onMenuShareTimeline", "onMenuShareAppMessage", "updateAppMessageShareData", "updateTimelineShareData"] // 此处填你所用到的方法
                        });
                        wx.ready(function () {
                            // 所以如果需要在页面加载时就调用相关接口，则须把相关接口放在ready函数中调用来确保正确执行。对于用户触发时才调用的接口，
                            // 则可以直接调用，不需要放在ready函数中。
                            console.log("wxReady");
                            if (wx.onMenuShareAppMessage) {
                                wx.onMenuShareAppMessage({
                                    // 分享给朋友
                                    title: config.title, // 分享标题
                                    desc: config.desc, // 分享描述
                                    link: config.shareUrl, // 分享链接 默认以当前链接
                                    imgUrl: config.imgUrl, // 分享图标
                                    // 用户确认分享后执行的回调函数
                                    success: function () {
                                        console.log("分享成功");
                                        alert("分享成功")
                                    },
                                    // 用户取消分享后执行的回调函数
                                    cancel: function () {
                                        console.log("分享到朋友取消");
                                    }
                                })
                                wx.onMenuShareTimeline({
                                    title: config.title, // 分享标题
                                    desc: config.desc, // 分享描述
                                    link: config.shareUrl, // 分享链接 默认以当前链接
                                    imgUrl: config.imgUrl, // 分享图标

                                    success: function () {
                                        // 用户确认分享后执行的回调函数
                                    },
                                    cancel: function () {
                                        // 用户取消分享后执行的回调函数
                                    }
                                })
                            } else {
                                wx.updateAppMessageShareData({
                                    // 分享给朋友
                                    title: config.title, // 分享标题
                                    desc: config.desc, // 分享描述
                                    link: config.shareUrl, // 分享链接 默认以当前链接
                                    imgUrl: config.imgUrl, // 分享图标
                                    // 用户确认分享后执行的回调函数
                                    success: function () {
                                        console.log("分享成功");
                                        alert("分享成功")
                                    },
                                    // 用户取消分享后执行的回调函数
                                    cancel: function () {
                                        console.log("分享到朋友取消");
                                    }
                                });
                                //分享到朋友圈
                                wx.updateTimelineShareData({
                                    title: config.title, // 分享标题
                                    desc: config.desc, // 分享描述
                                    link: config.shareUrl, // 分享链接 默认以当前链接
                                    imgUrl: config.imgUrl, // 分享图标

                                    success: function () {
                                        // 用户确认分享后执行的回调函数
                                    },
                                    cancel: function () {
                                        // 用户取消分享后执行的回调函数
                                    }
                                });
                            }
                        });
                        //处理验证失败的信息
                        wx.error(function (res) {
                            console.log("验证失败返回的信息:", res);
                        });
                    } else {
                        Toast('签名失败')
                    }
                })
                $(shareBt).on('click', function () {
                    config.shareBtCb && config.shareBtCb()
                    openShareMask()
                });
            }
        })
    } else if (isBangBangApp()) {
        $(shareBt).on('click', () => {
            config.shareBtCb && config.shareBtCb()
            if (!config.handleClick) {
                var timer = setInterval(function () {
                    let imgUrl = config.imgUrl
                    if (config.wxShareType && config.wxShareType === 'WXMiniProgram') {
                        imgUrl = config.miniAppImgUrl || 'https://static.shenzhoubb.com/images/miniapp/share.png'
                    }
                    let path = config.sharePath
                    if (config.shareUrl && config.wxShareType && config.wxShareType === 'WXMiniProgram') {
                        if (path === 'commonh5') {
                            path = `/pages/commonh5/commonh5?url=${encodeURIComponent(config.shareUrl)}`
                        } else {
                            path = `${config.sharePath}?url=${encodeURIComponent(config.shareUrl)}`
                        }
                    }
                    if (isAndroid()) {
                        if (window.synopsis.scriptMessage) {
                            clearInterval(timer)
                            window.synopsis.scriptMessage(
                                JSON.stringify({
                                    selName: "h5Share",
                                    paramsDic: {
                                        shareUrl: config.shareUrl,
                                        title: config.title,
                                        desc: config.desc,
                                        imgUrl,
                                        wxShareType: config.wxShareType,
                                        path,
                                        userName: 'gh_a99af4c90772'
                                    },
                                })
                            );
                        }
                    } else if (isIOS()) {
                        if (window.webkit.messageHandlers.scriptMessage) {
                            clearInterval(timer)
                            window.webkit.messageHandlers.scriptMessage.postMessage(
                                {
                                    selName: "h5Share",
                                    paramsDic: {
                                        shareUrl: config.shareUrl,
                                        title: config.title,
                                        desc: config.desc,
                                        imgUrl,
                                        thumbData: imgUrl,
                                        wxShareType: config.wxShareType,
                                        path,
                                        userName: 'gh_a99af4c90772'
                                    },
                                }
                            )
                        }
                    }
                }, 1000 / 60)
            } else {
                config.handleClick()
            }
        })
        window.callH5Share = function () {
            var timer = setInterval(function () {
                let imgUrl = config.imgUrl
                if (config.wxShareType && config.wxShareType === 'WXMiniProgram') {
                    imgUrl = config.miniAppImgUrl || 'https://static.shenzhoubb.com/images/miniapp/share.png'
                }
                let path = config.sharePath
                if (config.shareUrl && config.wxShareType && config.wxShareType === 'WXMiniProgram') {
                    if (path === 'commonh5') {
                        path = `/pages/commonh5/commonh5?url=${encodeURIComponent(config.shareUrl)}`
                    } else {
                        path = `${config.sharePath}?url=${encodeURIComponent(config.shareUrl)}`
                    }
                }
                if (isAndroid()) {
                    if (window.synopsis.scriptMessage) {
                        clearInterval(timer)
                        window.synopsis.scriptMessage(
                            JSON.stringify({
                                selName: "h5Share",
                                paramsDic: {
                                    shareUrl: config.shareUrl,
                                    title: config.title,
                                    desc: config.desc,
                                    imgUrl,
                                    wxShareType: config.wxShareType,
                                    path,
                                    userName: 'gh_a99af4c90772'
                                },
                            })
                        );
                    }
                } else if (isIOS()) {
                    if (window.webkit.messageHandlers.scriptMessage) {
                        clearInterval(timer)
                        window.webkit.messageHandlers.scriptMessage.postMessage(
                            {
                                selName: "h5Share",
                                paramsDic: {
                                    shareUrl: config.shareUrl,
                                    title: config.title,
                                    desc: config.desc,
                                    imgUrl,
                                    thumbData: imgUrl,
                                    wxShareType: config.wxShareType,
                                    path,
                                    userName: 'gh_a99af4c90772'
                                },
                            }
                        )
                    }
                }
            }, 1000 / 60)
        }
    } else {
        const nativeShare = new NativeShare();
        const shareData = {
            shareDesc: config.desc,
            shareFrom: "神州邦邦",
            shareTitle: config.title,
            // 如果是微信该link的域名必须要在微信后台配置的安全域名之内的。
            shareLink: config.shareUrl,
            icon: require("@/assets/images/Output84.png"),
            // 不要过于依赖以下两个回调，很多浏览器是不支持的
            success: function () {
                alert("success");
            },
            fail: function () {
                alert("fail");
            }
        };
        nativeShare.setShareData(shareData);
        $(shareBt).on("click", () => {
            config.shareBtCb && config.shareBtCb()
            try {
                nativeShare.call();
            } catch (err) {
                if ($.type(navigator.share) !== "undefined") {
                    navigator.share({
                        title: shareData.shareTitle,
                        text: shareData.shareDesc,
                        url: shareData.shareLink
                    });
                } else {
                    openShareMask()
                    config.handleClick && config.handleClick()
                }
            }
        });
    }
    function openShareMask() {
        if (!($('.share_mask').length > 0)) {
            $('body').append('<div class="share_mask">' +
                '<div class="share_arrow"></div>' +
                '<div class="share_text"></div>' +
                '</div>')
            $('body').delegate('.share_mask', 'click', function () {
                $('.share_mask').fadeOut(300)
            })
        }
        $('.share_mask').fadeIn(300)
    }
    this.reBind = function () {
        $(shareBt).off('click')
        if (isWeixin()) {
            $(shareBt).on('click', function () {
                config.shareBtCb && config.shareBtCb()
                openShareMask()
            });
        } else if (isBangBangApp()) {
            $(shareBt).on('click', () => {
                config.shareBtCb && config.shareBtCb()
                if (!config.handleClick) {
                    var timer = setInterval(function () {
                        let imgUrl = config.imgUrl
                        if (config.wxShareType && config.wxShareType === 'WXMiniProgram') {
                            imgUrl = config.miniAppImgUrl || 'https://static.shenzhoubb.com/images/miniapp/share.png'
                        }
                        let path = config.sharePath
                        if (config.shareUrl && config.wxShareType && config.wxShareType === 'WXMiniProgram') {
                            if (path === 'commonh5') {
                                path = `/pages/commonh5/commonh5?url=${encodeURIComponent(config.shareUrl)}`
                            } else {
                                path = `${config.sharePath}?url=${encodeURIComponent(config.shareUrl)}`
                            }
                        }
                        if (isAndroid()) {
                            if (window.synopsis.scriptMessage) {
                                clearInterval(timer)
                                window.synopsis.scriptMessage(
                                    JSON.stringify({
                                        selName: "h5Share",
                                        paramsDic: {
                                            shareUrl: config.shareUrl,
                                            title: config.title,
                                            desc: config.desc,
                                            imgUrl,
                                            wxShareType: config.wxShareType,
                                            path,
                                            userName: 'gh_a99af4c90772'
                                        },
                                    })
                                );
                            }
                        } else if (isIOS()) {
                            if (window.webkit.messageHandlers.scriptMessage) {
                                clearInterval(timer)
                                window.webkit.messageHandlers.scriptMessage.postMessage(
                                    {
                                        selName: "h5Share",
                                        paramsDic: {
                                            shareUrl: config.shareUrl,
                                            title: config.title,
                                            desc: config.desc,
                                            imgUrl,
                                            thumbData: imgUrl,
                                            wxShareType: config.wxShareType,
                                            path,
                                            userName: 'gh_a99af4c90772'
                                        },
                                    }
                                )
                            }
                        }
                    }, 1000 / 60)
                } else {
                    config.handleClick()
                }
            })
        } else {
            const nativeShare = new NativeShare();
            const shareData = {
                shareDesc: config.desc,
                shareFrom: "神州邦邦",
                shareTitle: config.title,
                // 如果是微信该link的域名必须要在微信后台配置的安全域名之内的。
                shareLink: config.shareUrl,
                icon: require("@/assets/images/Output84.png"),
                // 不要过于依赖以下两个回调，很多浏览器是不支持的
                success: function () {
                    alert("success");
                },
                fail: function () {
                    alert("fail");
                }
            };
            nativeShare.setShareData(shareData);
            $(shareBt).on("click", () => {
                config.shareBtCb && config.shareBtCb()
                try {
                    nativeShare.call();
                } catch (err) {
                    if ($.type(navigator.share) !== "undefined") {
                        navigator.share({
                            title: shareData.shareTitle,
                            text: shareData.shareDesc,
                            url: shareData.shareLink
                        });
                    } else {
                        openShareMask()
                        config.handleClick && config.handleClick()
                    }
                }
            });
        }
    }
}
//解析设备
const parseDevices = devicesJson => {
    let devices = []
    let _devicesJson = devicesJson
    if (_devicesJson) {
        _devicesJson = _devicesJson.replace('\r', '')
        _devicesJson = _devicesJson.split('\n');
    }
    let item = {}
    if (_devicesJson && devicesJson.length > 0) {
        _devicesJson.forEach((element, index) => {
            switch (index % 4) {
                case 0:
                    item.name = element ? element.split(':')[1] ? element.split(':')[1] : element.split('：')[1] : ''
                    break;
                case 1:
                    item.type = element ? element.split(':')[1] ? element.split(':')[1] : element.split('：')[1] : ''
                    break;
                case 2:
                    item.num = element ? element.split(':')[1] ? element.split(':')[1] : element.split('：')[1] : ''
                    break;
                case 3:
                    item.code = element ? element.split(':')[1] ? element.split(':')[1] : element.split('：')[1] : ''
                    devices.push(JSON.stringify(item))
                    break;
                default:
                    break;
            }
        });
        devices = devices.map((item, index, array) => {
            return JSON.parse(item)
        })
    }
    return devices
}
//服务类型图标
const getServiceTypeIcon = ({ serviceType, type }) => {
    let iconType = ''
    if (type === 1) {
        switch (serviceType) {
            case '故障处理':
                iconType = require('@/assets/images/ticket/icon8.png')
                break;
            case '培训':
                iconType = require('@/assets/images/ticket/icon14.png')
                break;
            case '咨询服务':
                iconType = require('@/assets/images/ticket/icon13.png')
                break;
            case '人员招聘':
                iconType = require('@/assets/images/ticket/icon15.png')
                break;
            case '安装调试':
                iconType = require('@/assets/images/ticket/icon9.png')
                break;
            case '其他':
                iconType = require('@/assets/images/ticket/icon16.png')
                break;
            case '设备巡检':
                iconType = require('@/assets/images/ticket/icon11.png')
                break;
            case '二线支持':
                iconType = require('@/assets/images/ticket/icon8.png')
                break;
            case '驻场值守':
                iconType = require('@/assets/images/ticket/icon10.png')
                break;
            case '售前支持':
                iconType = require('@/assets/images/ticket/icon12.png')
                break;
            default:
                iconType = require('@/assets/images/ticket/icon8.png')
        }
    }
    if (type === 2) {
        switch (serviceType) {
            case '故障处理':
                iconType = require('@/assets/images/ticket/icon1.png')
                break;
            case '培训':
                iconType = require('@/assets/images/ticket/icon7.png')
                break;
            case '咨询服务':
                iconType = require('@/assets/images/ticket/icon6.png')
                break;
            case '人员招聘':
                iconType = require('@/assets/images/ticket/icon21.png')
                break;
            case '安装调试':
                iconType = require('@/assets/images/ticket/icon2.png')
                break;
            case '其他':
                iconType = require('@/assets/images/ticket/icon22.png')
                break;
            case '设备巡检':
                iconType = require('@/assets/images/ticket/icon4.png')
                break;
            case '二线支持':
                iconType = require('@/assets/images/ticket/icon1.png')
                break;
            case '驻场值守':
                iconType = require('@/assets/images/ticket/icon3.png')
                break;
            case '售前支持':
                iconType = require('@/assets/images/ticket/icon5.png')
                break;
            default:
                iconType = require('@/assets/images/ticket/icon1.png')
        }
    }
    return iconType
}
//微信小程序中使用requestAnimationFrame
const requestAnimationFrame = function (callback, lastTime) {
    var lastTime;
    if (typeof lastTime === 'undefined') {
        lastTime = 0
    }
    var currTime = new Date().getTime();
    var timeToCall = Math.max(0, 30 - (currTime - lastTime));
    lastTime = currTime + timeToCall;
    var id = setTimeout(function () {
        callback(lastTime);
    }, timeToCall);
    return id;
};
const cancelAnimationFrame = function (id) {
    clearTimeout(id);
};
const navigateToApp = (url) => {
    if (isBangBangApp()) {
        if (isAndroid()) {
            window.synopsis.navigateTo(
                url
            );
            return;
        }
        if (isIOS()) {
            window.webkit.messageHandlers.navigateTo.postMessage(
                url
            );
        }
    }
}
const appOpenMiniProgram = (url) => {
    if (isBangBangApp()) {
        postMessageToAPP({
            selName: "openMiniProgram",
            paramsDic: {
                url,
            },
        });
    }
}
const navigateBackApp = (url) => {
    if (isBangBangApp()) {
        if (isAndroid()) {
            window.synopsis.navigateBack();
            return;
        }
        if (isIOS()) {
            window.webkit.messageHandlers.navigateBack.postMessage("");
        }
    }
}
const checkPassword = function (password) {
    var patrn = /^(\w){6,20}$/;
    if (!patrn.exec(password)) return true
}
const geolocation = function () {
    const txLocate = (success, error) => {
        const geolocation = new Geolocation('3FZBZ-VZ463-UDR3Z-O5QTF-3XGB6-NKF6R', '我的应用');
        geolocation.getLocation(success, error);
    }
    return new Promise((resolve, reject) => {
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition((position) => {
                resolve({
                    lng: position.coords.longitude,
                    lat: position.coords.latitude
                })
            }, (err) => {
                txLocate((position) => {
                    resolve(position)
                }, (error) => {
                    reject(error)
                })
            });
        } else {
            txLocate((position) => {
                resolve(position)
            }, (error) => {
                reject(error)
            })
        }

    })
}
const getAMap = function () {
    return new Promise((resolve, reject) => {
        if (!window.TMap) {
            window.TMap = {};
            window._initBaiduMap = function () {
                window.document.body.removeChild($script2);
                window._initBaiduMap = null;
                resolve(window.TMap);
            };
            const $script2 = document.createElement("script");
            window.document.body.appendChild($script2);
            $script2.src = `https://map.qq.com/api/gljs?v=1.exp&key=3FZBZ-VZ463-UDR3Z-O5QTF-3XGB6-NKF6R&callback=_initBaiduMap`;
        } else {
            resolve(window.TMap);
        }
    });
}
const postMessageToAPP = function ({ selName, paramsDic }) {
    const timer = setInterval(() => {
        if (isAndroid()) {
            if (window.synopsis.scriptMessage) {
                clearInterval(timer);
                window.synopsis.scriptMessage(
                    JSON.stringify({
                        selName,
                        paramsDic,
                    })
                );
            }
        }
        if (isIOS()) {
            if (window.webkit.messageHandlers.scriptMessage) {
                clearInterval(timer);
                window.webkit.messageHandlers.scriptMessage.postMessage(
                    {
                        selName,
                        paramsDic
                    }
                );
            }
        }
    }, 1000 / 60);
}
const getFileIcon = function (fileType, path) {
    let icon = require('@/assets/images/file/file.png')
    switch (fileType) {
        case 'doc':
        case 'docx':
            icon = require('@/assets/images/file/word.png')
            break;
        case 'jpg':
        case 'png':
        case "jpeg":
        case 'image/jpg':
        case 'image/png':
            icon = path
            break;
        case 'xls':
        case 'xlsx':
            icon = require('@/assets/images/file/excel.png')
            break;
        case 'ppt':
        case 'pptx':
            icon = require('@/assets/images/file/ppt.png')
            break;
        case 'pdf':
            icon = require('@/assets/images/file/pdf.png')
            break;
        case 'file':
            icon = require('@/assets/images/file/file.png')
            break;
    }
    return icon
}

const IMAGE_REGEXP = /\jpeg|jpg|gif|png|svg|webp|jfif|bmp|dpg|image/i;
const isImageUrl = function (url) {
    return IMAGE_REGEXP.test(url);
}
const objDeepCopy = (source) => {
    if (typeof source === 'object') {
        var sourceCopy = source instanceof Array ? [] : {}
        for (var item in source) {
            if (!source[item]) {
                sourceCopy[item] = source[item]
            } else {
                sourceCopy[item] = typeof source[item] === 'object' ? objDeepCopy(source[item]) : source[item]
            }
        }
        return sourceCopy
    }
    return source
}
/** 判断输入的是number */
const regexIsNumber = (nubmer) => {
    var regex = /^[0-9]+.?[0-9]*/
    if (!regex.test(nubmer)) {
        return false
    }
    return true
}

/** 判断输入的是crm数字 数字的整数部分须少于15位，小数部分须少于4位*/
const regexIsCRMNumber = (nubmer) => {
    var regex = /^([-+]?\d{1,15})(\.\d{0,4})?$/
    if (!regex.test(nubmer)) {
        return false
    }
    return true
}

/** 判断输入的是货币 货币的整数部分须少于15位，小数部分须少于2位*/
const regexIsCRMMoneyNumber = (nubmer) => {
    var regex = /^([-+]?\d{1,15})(\.\d{0,2})?$/
    if (!regex.test(nubmer)) {
        return false
    }
    return true
}

/** 判断输入的是电话*/
const regexIsCRMMobile = (mobile) => {
    var regex = /^(\+?0?\d{2,4}\-?)?\d{6,11}$/
    if (!regex.test(mobile)) {
        return false
    }
    return true
}
const regexIsCRMEmail = (email) => {
    var regex = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/
    if (!regex.test(email)) {
        return false
    }
    return true
}
const openCustomerServiceChat = (confihg) => {
    get({
        url: api + "api/qiyeWechat/getKfUrl",
        data: {
            sceneParam: confihg?.sceneParam,
            scene: confihg?.scene || 'DEFAULT'
        },
        requestType: 3,
    }).then(data => {
        if (data.result === 'success') {
            location.href = data.body?.url
        }
    })

}
/**
 * path  和 name
 */
const downloadFile = (data) => {
    var x = new XMLHttpRequest();

    var loadingInstance = Toast.loading({
        message: '正在下载...',
    });
    x.open("GET", data.path, true);
    x.responseType = 'blob';
    x.onprogress = function (event) {
        if (event.lengthComputable) {
            var loaded = parseInt(event.loaded / event.total * 100) + "%";
            loadingInstance.message = `正在下载${loaded}`;
        }
    }
    x.onload = function (e) {
        const blob = new Blob([x.response], {
            type: ''
        })
        downloadFileWithBuffer(blob, data.name || '文件')
        loadingInstance.clear()
    }
    x.send();
}
function downloadFileWithBuffer(data, name, type) {
    var blob = new Blob([data], {
        type: type || ''
    })
    var downloadElement = document.createElement('a')
    var href = window.URL.createObjectURL(blob) // 创建下载的链接
    downloadElement.href = href
    downloadElement.download = name // 下载后文件名
    document.body.appendChild(downloadElement)
    downloadElement.click() // 点击下载
    document.body.removeChild(downloadElement) // 下载完成移除元素
    window.URL.revokeObjectURL(href) // 释放掉blob对象
}
function loadJs(src) {
    return new Promise((resolve, reject) => {
        let script = document.createElement('script');
        script.type = "text/javascript";
        script.src = src;
        document.body.appendChild(script);

        script.onload = () => {
            resolve();
        }
        script.onerror = () => {
            reject();
        }
    })
}
/**
 * 获取uuid
 */
function getUUID() {
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, c => {
        return (c === "x" ? (Math.random() * 16) | 0 : "r&0x3" | "0x8").toString(
            16
        );
    });
}
/**
 * 数据非空验证
 * @desc 验证数据是否为 null undefined [] {} ''
 * @param data
 * @return {boolean}
 */
function isEmpty(data) {
    if (data === null) return true
    if (data === undefined) return true
    if (Object.prototype.toString.call(data) === '[object Array]') return data.length === 0
    if (Object.prototype.toString.call(data) === '[object Object]') return Object.keys(data).length === 0
    if (typeof data === 'string') return data.trim() === ''
    return false
}
export {
    isWeixin,
    isAndroid,
    isAlipay,
    isIOS,
    isHarmonyOS,
    getWXEvn,
    isBangBangApp,
    getCookie,
    setCookie,
    clearCookie,
    getQueryString,
    initLogin,
    openCustomerServiceChat,
    initLogin2,
    clearForm,
    checkPhoneNo,
    compressImg,
    initShare,
    geolocation,
    parseDevices,
    downloadFile,
    dataURLtoBlob,
    blobToFile,
    requestAnimationFrame,
    cancelAnimationFrame,
    openLoginPop,
    navigateToApp,
    getServiceTypeIcon,
    checkLogin,
    checkPassword,
    getLocalStorage,
    setLocalStorage,
    removeLocalStorage,
    getAMap,
    postMessageToAPP,
    navigateBackApp,
    isImageUrl,
    getFileIcon,
    objDeepCopy,
    regexIsCRMNumber,
    regexIsCRMMoneyNumber,
    regexIsCRMMobile,
    regexIsCRMEmail,
    regexIsNumber,
    loadJs,
    getUUID,
    isEmpty,
    appOpenMiniProgram
}